import { Button, Card, Field, Input } from '@aurora/ui-kit';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { ApiError } from '../api/client.js';
import { useLogin } from '../auth/useAuth.js';
import { brandingLogoUrl, useBranding } from '../state/branding.js';
import { tenantStore } from '../state/tenant.js';

export function LoginPage() {
  const navigate = useNavigate();
  const login = useLogin();
  const branding = useBranding();
  const logoUrl = brandingLogoUrl(branding, tenantStore.get());
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const errorMessage =
    login.error instanceof ApiError
      ? login.error.status === 429
        ? 'Zu viele Versuche — bitte kurz warten.'
        : login.error.message
      : login.error
        ? 'Anmeldung fehlgeschlagen.'
        : undefined;

  return (
    <div className="login">
      <div className="login__panel">
        <div className="login__brand">
          {logoUrl !== null ? (
            <img className="login__brand-logo" src={logoUrl} alt="" />
          ) : (
            <span className="shell__brand-mark">{branding?.brandMark ?? '◈'}</span>
          )}
          <h1>{branding?.brandName ?? 'Aurora ERP'}</h1>
          <p>Melde dich an, um fortzufahren.</p>
        </div>
        <Card>
          <form
            className="login__form"
            onSubmit={(event) => {
              event.preventDefault();
              login.mutate(
                { email, password },
                { onSuccess: () => void navigate('/', { replace: true }) },
              );
            }}
          >
            <Field label="E-Mail" {...(errorMessage !== undefined ? { error: errorMessage } : {})}>
              {(id, invalid) => (
                <Input
                  id={id}
                  type="email"
                  autoComplete="username"
                  required
                  value={email}
                  aria-invalid={invalid}
                  onChange={(event) => setEmail(event.target.value)}
                />
              )}
            </Field>
            <Field label="Passwort">
              {(id) => (
                <Input
                  id={id}
                  type="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
              )}
            </Field>
            <Button type="submit" loading={login.isPending}>
              Anmelden
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
